import * as yup from 'yup'

export const Ros2Schema = yup.object({
    menstrual: yup
        .string()
        .dateSmallerThan1900('This date is too far in the past.')
})
